import React from 'react';
import styled from 'styled-components';

// Storybook reference:https://ui-standard.hackhub.com/?path=/story/styleguide-uicomponents-buttons--button-group

const BtnStyle = styled.button`
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-size: ${props => (props.isSmall ? '16px' : '18px')};
  font-weight: 500;
  background-color: ${props => (props.isPrimary ? '#0094FB' : 'transparent')};
  outline: none;
  line-height: 28px;
  border: ${(props) => (props.isPrimary ? '1px solid transparent' : '1px solid #fff')};
  padding: 0.6em 1.2em;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;

  &:hover:enabled {
    background-color: #0094fb;
    opacity: 0.8;
    border: 1px solid transparent;
  }

  :disabled {
    background: #F1F4F9;
    border: 1px solid #99B2C6;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #9BA1AA;
    cursor: none;
  }
`;

export const OrginalButton = BtnStyle;

export const Button = ({
  isPrimary, isSmall, label, ...props
}) => (
  <BtnStyle isPrimary={isPrimary} isSmall={isSmall} {...props}>
    {label}
  </BtnStyle>
);


Button.defaultProps = {
  isPrimary: true,
  isSmall: false,
  onClick: undefined
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/button.js